exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".grid-frecuentes{\r\n    width: 280px;\r\n    padding-right: 5px;\r\n    padding-left: 0px;\r\n}  \r\n\r\n.fuente-h4{\r\n    color: rgba(247, 242, 242, 0.904);\r\n}\r\n\r\n.lista-vacia{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    padding: 0px;\r\n    margin: 0px;\r\n\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/portal/components/sidebar/components/frecuentes/lista-frecuente/lista-frecuentes.style.css
// module id = 634
// module chunks = 0